module.exports = __webpack_public_path__ + "img/vertical_2_1_8023.c4a50eac.png";